/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import t from "../../../../trans";
import ExpandableSiblingTemplate from "./ExpandableSiblingTemplate";

class ExpandableTemplate extends ExpandableSiblingTemplate {
    static propTypes = {
        id: PropTypes.string,
        classNames: PropTypes.string,
        label: PropTypes.string,
        children: PropTypes.node.isRequired,
        errors: PropTypes.element,
        rawErrors: PropTypes.arrayOf(PropTypes.string),
        help: PropTypes.element,
        rawHelp: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        description: PropTypes.element,
        rawDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        hidden: PropTypes.bool,
        required: PropTypes.bool,
        readonly: PropTypes.bool,
        displayLabel: PropTypes.bool,
        fields: PropTypes.object,
        formContext: PropTypes.shape({
            expanded: PropTypes.bool,
            expandedCallback: PropTypes.func,
            onSubmit: PropTypes.func
        }),
        schema: PropTypes.object.isRequired,
        uiSchema: PropTypes.object
    };

    static defaultProps = {
        hidden: false,
        readonly: false,
        required: false,
        displayLabel: true,
        uiSchema: {}
    };

    constructor(props) {
        super(props);
        this.state = {
        };
        this.onClick = this.onClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onClick(e) {
        e.preventDefault();
        if (this.props.formContext.expandedCallback) this.props.formContext.expandedCallback();
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.props.formContext.onSubmit) this.props.formContext.onSubmit();
    }

    getTemplateClassName() {
        return super.getTemplateClassName() + " form-group-ibox-title";
    }

    renderSubmitButton() {
        let actions = this.props.uiSchema["ui:action"];
        if (actions && !_.isArray(actions)) actions = [actions];

        let buttonLabel = null;
        if (actions && actions.length > 0) {
            buttonLabel = actions[0].label;
        } else {
            buttonLabel = t("Search");
        }
        if (!buttonLabel) return null;
        return (
            <div className="col-sm-2">
                <button className="btn btn-primary" type="submit">{buttonLabel}</button>
            </div>
        );
    }

    render() {
        if (this.props.hidden) return this.props.children;

        return (
            <div className={this.getTemplateClassName()}>
                {this.renderLabel()}
                {this.renderField()}

                {this.renderSubmitButton()}

                <div className="col-sm-1">
                    <div className="ibox-tools">
                        <a className="collapse-link" onClick={this.onClick}>
                            <i className={"fa fa-chevron-" + (this.props.formContext.expanded ? "up" : "down") }/>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExpandableTemplate;
